import { useSelector } from 'react-redux'

import { DarkEditDeviceModal, useDeviceModals } from '@/features/device-crud'
import { DeviceType } from '@/graphql/generated/schemas'
import { selectDevice } from '@/redux/ui/uiSlice'
import { MODAL_Z_INDEX } from '@/styles/theme'

import { DarkACDeviceDrawer } from '../dark/components/DarkACDeviceDrawer'
import { DarkCameraDeviceDrawer } from '../dark/components/DarkCameraDeviceDrawer'

interface IProps {
  isOpen: boolean
  onClose: () => void
}

export const DeviceDrawer = ({ isOpen, onClose }: IProps) => {
  const { id, type } = useSelector(selectDevice)
  const { openEditDevice, onEditDeviceClose, isEditDeviceOpen, deviceData } =
    useDeviceModals()

  const renderDrawer = () => {
    // The component stays mounted while the drawer is closed so the edit modal
    // below outlives it — the drawer itself, and the device query
    // behind it, must still come down.
    if (!isOpen) return null

    switch (type) {
      case DeviceType.Camera:
        return (
          <DarkCameraDeviceDrawer
            defaultIndex={0}
            deviceId={id}
            isOpen={isOpen}
            onClose={onClose}
            onEditClick={openEditDevice}
          />
        )
      case DeviceType.Door:
        return (
          <DarkACDeviceDrawer
            defaultIndex={0}
            deviceId={id}
            isOpen={isOpen}
            onClose={onClose}
            onEditClick={openEditDevice}
          />
        )
      // Alarm and Checkpoint have no drawer. Callers gate on
      // `isDeviceDrawerSupported` so this is unreachable in practice; keep the
      // two in sync when adding a type.
      default:
        return null
    }
  }

  return (
    <>
      {renderDrawer()}
      {/* Deliberately outside `renderDrawer`'s `isOpen` gate: `deviceData` is a
          snapshot taken when edit was clicked, so the modal stays open and
          usable after the drawer beneath it closes. */}
      {isEditDeviceOpen && (
        <DarkEditDeviceModal
          deviceData={deviceData}
          isOpen={isEditDeviceOpen}
          onClose={onEditDeviceClose}
          zIndex={MODAL_Z_INDEX}
        />
      )}
    </>
  )
}
